import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';

const CodeBlock = ({ blok }) => {
  // TODO: Sanitize HTML input

  return (
    <div
      className="w-full"
      dangerouslySetInnerHTML={{ __html: blok.html_input }}
      {...storyblokEditable(blok)}
    ></div>
  );
};

export default CodeBlock;
